import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'

import PageMenuDropdown from '../PageMenuDropdown'
import UserMenuDropdown from '../UserMenuDropdown'

import { GirlColor, BoyColor, Hamburger } from '../../Icons'
import { Overlay, Wrap, Item, IconContainer } from './styles'

class BottomBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      assortActive: false,
      companyActive: false,
      serviceActive: false,
      userMenuActive: false,
      pageMenuActive: false
    }
  }

  handleUserMenuClick() {
    this.setState({
      userMenuActive: !this.state.userMenuActive,
      pageMenuActive: false
    })
    document.body.classList.toggle('popup-active')
    document.documentElement.classList.toggle('popup-active')
  }

  handlePageMenuClick() {
    this.setState({
      pageMenuActive: !this.state.pageMenuActive,
      userMenuActive: false
    })
    document.body.classList.toggle('popup-active')
    document.documentElement.classList.toggle('popup-active')
  }

  handleClickAssort() {
    this.setState({ assortActive: !this.state.assortActive })
  }

  handleClickCompany() {
    this.setState({ companyActive: !this.state.companyActive })
  }

  handleClickService() {
    this.setState({ serviceActive: !this.state.serviceActive })
  }

  handleClickOutside() {
    this.setState({
      userMenuActive: false,
      pageMenuActive: false
    })
    document.body.classList.remove('popup-active')
    document.documentElement.classList.remove('popup-active')
  }

  handleSwitchBranch() {
    this.props.onSwitchBranch()
    this.setState({
      userMenuActive: false,
      pageMenuActive: false
    })
  }

  render() {
    const { assortActive, companyActive, userMenuActive, pageMenuActive, serviceActive } = this.state

    return (
      <Fragment>
        <Wrap>
          <Item active={userMenuActive}>
            <IconContainer onClick={this.handleUserMenuClick.bind(this)}>
              {this.props.gender === 'MALE' ? <BoyColor size="" /> : <GirlColor size="" />}
            </IconContainer>

            <UserMenuDropdown
              branchName={this.props.branchName}
              onClickLink={this.handleUserMenuClick.bind(this)}
              onSwitchBranch={this.handleSwitchBranch.bind(this)}
              handleLogout={this.props.handleLogout}
              permissions={this.props.permissions}
              gender={this.props.gender}
            />
          </Item>

          <Item onClick={this.handleClickOutside.bind(this)} />
          <Item onClick={this.handleClickOutside.bind(this)} />

          <Item active={pageMenuActive}>
            <IconContainer onClick={this.handlePageMenuClick.bind(this)}>
              <Hamburger size="" />
            </IconContainer>

            <PageMenuDropdown
              assortActive={assortActive}
              companyActive={companyActive}
              serviceActive={serviceActive}
              onClickLink={this.handlePageMenuClick.bind(this)}
              onClickBackAssort={this.handleClickAssort.bind(this)}
              onClickBackCompany={this.handleClickCompany.bind(this)}
              onClickBackService={this.handleClickService.bind(this)}
              onClick={this.handlePageMenuClick.bind(this)}
              permissions={this.props.permissions}
              nrOfOrders={this.props.nrOfOrders}
            />
          </Item>
        </Wrap>

        {userMenuActive || pageMenuActive ? <Overlay onClick={this.handleClickOutside.bind(this)} /> : null}
      </Fragment>
    )
  }
}

export default withRouter(BottomBar)



// WEBPACK FOOTER //
// ./src/components/MobileHeader/BottomBar/index.js